export const AuthURL = "user/";
export const RecordURL = "RECORD/";
export const EncodeURL = "Encoding/";
export const LinkURL = "RECORD/";
export const StatURL = "Stat/";
export const DataURL = "DATA/";
export const VerifyURL = "Verify/";
export const RequestURL = "Download/";
export const MergeURL = "Merge/";
export const BaseURL = "https://api.orange-green.cc/";
export const LogURL = "Log/";
